/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import AiSummary from './icon-ai-summary.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <AiSummary {...validProps} />;
}
SvgComponent.iconName = 'aiSummary';

export const AiSummaryIcon = svgIconWrapper(SvgComponent);
